export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8" data-testid={testid}>
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-[#475569] mb-2">
          Painel
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0F172A] tracking-tight leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-[#475569] mt-1.5 max-w-xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, accent = false, icon: Icon, testid }) {
  return (
    <div
      className={`bg-white border ${accent ? "border-[#00B0F0]" : "border-[#E2E8F0]"} rounded-md p-6 card-hover`}
      data-testid={testid}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="text-[11px] uppercase tracking-[0.2em] text-[#475569]">{label}</div>
        {Icon && (
          <div className={`w-8 h-8 rounded-md flex items-center justify-center ${accent ? "bg-[#00B0F0]/10 text-[#00B0F0]" : "bg-[#001E50]/5 text-[#001E50]"}`}>
            <Icon size={16} weight="duotone" />
          </div>
        )}
      </div>
      <div className="font-heading text-3xl font-semibold text-[#0F172A] tracking-tight">{value}</div>
      {hint && <div className="text-xs text-[#475569] mt-2">{hint}</div>}
    </div>
  );
}

export function EmptyState({ title, message }) {
  return (
    <div className="text-center py-16 text-[#475569]" data-testid="empty-state">
      <div className="font-heading text-lg text-[#0F172A] mb-1">{title}</div>
      <div className="text-sm">{message}</div>
    </div>
  );
}

export function StatusChip({ status }) {
  const map = {
    aberta: ["chip chip-open", "Aberta"],
    em_andamento: ["chip chip-progress", "Em andamento"],
    finalizada: ["chip chip-done", "Finalizada"],
    cancelada: ["chip chip-cancel", "Cancelada"],
    pendente: ["chip chip-pending", "Pendente"],
    pago: ["chip chip-paid", "Pago"],
  };
  const [cls, label] = map[status] || ["chip", status];
  return <span className={cls}>{label}</span>;
}
